<template>
	<div class="file-upload-container">
		<label v-bind:for="labelFor" class="upload-file">
			<img v-if="previewImage" class="default-image" v-bind:src="imageUrl" alt="default logo"
			  width="46.8" height="38" />
			<a v-else v-bind:href="imageUrl" target="_blank" rel="noopener">Open File</a>
			<div class="camera-button">
				<img src="/static/img/camera.png" alt="camera button" width="13.3" height="10.8"
				/>
			</div>
			<span class="min-text" v-if="!disableValidation">MIN. {{minResolution}}x{{minResolution}}</span>
			<span class="allowed-files">{{allowedFiles.join(', ')}}</span>
			<input v-bind:id="labelFor" type="file" hidden v-on:change="onFileSelected"
			/>
		</label>
	</div>
</template>

<script>

const FILE_INFORMATION_EVENT = 'file-info';
const FILE_INFORMATION_ERROR = 'file-error';

function onFileSelected(e) {
	const minResolution = this.minResolution;
	const file = e.target.files[0];
	if (file) {
		const extArray = file.name.split('.');
		const fileExt = extArray[extArray.length - 1];
		if (this.allowedFiles.indexOf(fileExt.toUpperCase()) === -1) {
			this.$emit(FILE_INFORMATION_ERROR, 'type-not-allowed');
		} else {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);
			fileReader.addEventListener('load', () => {
				const response = file;
				response.result = fileReader.result;
				response.ext = fileExt;
				if (this.disableValidation) {
					this.$emit(FILE_INFORMATION_EVENT, response, this.labelFor);
				} else {
					const tempImage = document.createElement('img');
					tempImage.addEventListener('load', (imageEvent) => {
						const imgWidth = imageEvent.path[0].width;
						const imgHeight = imageEvent.path[0].height;
						if (minResolution > imgWidth || minResolution > imgHeight) {
							this.$emit(FILE_INFORMATION_ERROR, 'resolution-not-allowed');
						} else {
							this.$emit(FILE_INFORMATION_EVENT, response, this.labelFor);
						}
					});
					tempImage.src = fileReader.result;
				}
			});
		}
	}
}

export default {
	name: 'file-upload',
	props: {
		allowedFiles: {
			type: Array,
			default: () => ['JPG', 'JPEG', 'PNG', 'GIF'],
		},
		disableValidation: {
			type: Boolean,
			default: false,
		},
		imageUrl: {
			type: String,
			required: true,
		},
		labelFor: {
			type: [String, Number],
			required: true,
		},
		maxResolution: {
			type: Number,
			default: 500,
		},
		minResolution: {
			type: Number,
			default: 500,
		},
		previewImage: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		onFileSelected,
	},
};
</script>

<style lang="scss" scoped>
.file-upload-container {
	align-content: center;
	background-color: white;
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
	display: flex;
	height: 100%;
	justify-content: center;
	padding: 16px 0;
	width: 100%;
}

.upload-file {
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;

	.allowed-files {
		color: map-get($colors, grey-slate);
		font-family: 'San Francisco Display';
		font-size: map-get($sizes, ten);
		height: 12px;
		letter-spacing: -0px;
		text-align: center;
		width: 83px;
	}

	.camera-button {
		background-color: map-get($colors, cyan);
		border-radius: 5px;
		cursor: pointer;
		height: 20px;
		margin-bottom: 5px;
		text-align: center;
		width: 36px;
	}

	.default-image {
		margin-bottom: 16px;
	}

	.min-text {
		color: map-get($colors, grey-slate);
		font-family: 'San Francisco Display';
		font-size: map-get($sizes, eleven);
		font-weight: 600;
		height: 14px;
		letter-spacing: -0.1px;
		width: auto;
	}
}
</style>





// WEBPACK FOOTER //
// FileUpload.vue?913115a2